/**
 * Web core
 */

window.HE.Web = (function Web($, HE)
{
	"use strict";
	var web = {};

	web.lazyImages = lozad('.lazy');

	$(document).ready(function documentReady()
	{
		web.lazyImages.observe();
		_initExpandCollapse();
	});

	function _initExpandCollapse() {
		$('.string-expand-collapse').click(function truncate() {
			var $self      = $(this),
			    id         = $self.data("id"),
			    $expanded  = $('#expanded_' + id),
			    $collapsed = $('#collapsed_' + id);

			if ($expanded.css('display') === 'none') {
				$collapsed.hide();
				$expanded.show();
				$self.attr('src', HE.base_uri + '/images/expand.gif');
			} else {
				$collapsed.show();
				$expanded.hide();
				$self.attr('src', HE.base_uri + '/images/collapse.gif');
			}
		});
	}

	return web;
}(jQuery, window.HE || {}));
